<div class="notification-center">
  @for (notification of notifications; track notification) {
  <div [@animation]="getAnimation()">
    <notification [notification]="notification" (dismissed)="remove(notification)"></notification>
  </div>
  }
</div>
